<script>
export default {
  name: "stayUpToDate"
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #2D2D2D">
    <el-col :span="24" style="padding: 40px 16px">
      <span class="stay-up-to-date-title">Stay up to date</span>
    </el-col>
    <el-col :span="24">
      <div class="div-54">
        <img
          class="img-8"
          loading="lazy"
          src="../../assets/stay-up-to-date-1.jpg"
        />
        <div class="div-55">The features renters want most</div>
        <div class="div-56">
          <div class="div-57">Read more</div>
          <img class="img-9" loading="lazy" src="../../assets/Chevrons.svg" />
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="div-54">
        <img
          class="img-8"
          loading="lazy"
          src="../../assets/stay-up-to-date-2.jpg"
        />
        <div class="div-55">What does RBA price rises mean for you?</div>
        <div class="div-56">
          <div class="div-57">Read more</div>
          <img class="img-9" loading="lazy" src="../../assets/Chevrons.svg" />
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="div-54">
        <img
          class="img-8"
          loading="lazy"
          src="../../assets/stay-up-to-date-3.jpg"
        />
        <div class="div-55">How to pick the right agent</div>
        <div class="div-56">
          <div class="div-57">Read more</div>
          <img class="img-9" loading="lazy" src="../../assets/Chevrons.svg" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.div-54 {
  disply: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  display: flex;
  min-height: 400px;
  padding: 45px 42px;
}

.img-8 {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.7;
}

.div-55 {
  position: relative;
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  margin-top: 218px;
  font: 600 30px Metropolis, sans-serif;
}

.div-56 {
  position: relative;
  align-items: start;
  align-self: start;
  display: flex;
  margin-top: 12px;
  gap: 8px;
}

.div-57 {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  text-transform: uppercase;
  flex-grow: 1;
  white-space: nowrap;
  font: 700 18px Metropolis, sans-serif;
}

.img-9 {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
  overflow: hidden;
  align-self: stretch;
  max-width: 100%;
}

.stay-up-to-date-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/package/stayUpToDate.vue